import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = (props) => (
  <Header {...props}>
    IBM Fusion Technical Community
  </Header>
);

export default CustomHeader;
